<template>
    <a
        v-if="isSubdomain"
        :href="$page.props.locale == 'fr' ? `${$page.props.appUrl}/evenements/${event.slug}` : `${$page.props.appUrl}/events/${event.slug}`"
        target="_blank"
        rel="noopener noreferrer"
    >
        <div class="relative h-[250px] overflow-hidden rounded-xl shadow-xl md:h-[350px]">
            <img loading="lazy" :src="event.banner" alt="" class="h-full w-full object-cover" />

            <div class="absolute inset-0 bg-black bg-opacity-50"></div>

            <div class="absolute inset-0 flex flex-col justify-end p-8">
                <h1 class="text-2xl font-bold leading-tight text-white">{{ title }}</h1>
                <p class="text-white">{{ event.company.name }}</p>
            </div>
        </div>
    </a>

    <a
        v-else
        :href="$page.props.locale == 'fr' ? `/evenements/${event.slug}` : `/en/events/${event.slug}`"
        target="_blank"
        rel="noopener noreferrer"
    >
        <div class="relative h-[250px] overflow-hidden rounded-xl shadow-xl md:h-[350px]">
            <img loading="lazy" :src="event.banner_path" alt="" class="h-full w-full object-cover" />

            <div class="absolute inset-0 bg-black bg-opacity-50"></div>

            <div class="absolute inset-0 flex flex-col justify-end p-8">
                <h1 class="text-2xl font-bold leading-tight text-white">{{ title }}</h1>
                <p class="text-white">{{ event.company_name }}</p>
            </div>
        </div>
    </a>
</template>

<script setup>
    import { usePage } from '@inertiajs/inertia-vue3';
    import { computed } from 'vue';

    const props = defineProps({
        event: Object,
        isSubdomain: {
            type: Boolean,
            default: false,
        },
    });

    const title = computed(() => {
        return usePage().props.value.locale == 'fr' ? props.event.title_fr : props.event.title_en;
    });
</script>
